import { Box, Breadcrumbs, Button, Divider, Menu, MenuItem, Stack, Typography } from '@mui/material'
import { LinkRouter } from 'components/breadcrumbs'
import { PopupMenu } from 'components/common/SubMenuPopup'
import FacilityConfigContext from 'contexts/FacilityConfigContext'
import { useModulePermission } from 'hooks/useModulePermission'
import { usePermission } from 'hooks/usePermission'
import { useContext } from 'react'
import {  useParams } from 'react-router-dom'
import { getKeyValueorDefault, getKeyValueOrDefaultNested } from 'utils/utils'

type IPSESubMenu = {
  audit_id?: string | undefined
  asset_name?: string
}

export default function PSESubMenu({ audit_id, asset_name }: IPSESubMenu) {
  const { project_id, asset_id } = useParams()


  const { config } = useContext(FacilityConfigContext)
  const { checkProjectPermission } = useModulePermission()
  const { checkSubprojectPermission } = usePermission()
  
  // project level permissions
  const showBarrierManagement = checkProjectPermission({ action: "BarrierManagement:GetModuleAccess", type: "read" })
  const showProcessSafetyElements = checkProjectPermission({ action: "ProcessIntegrity:GetModuleAccess", type: "read" })
  const showAssuranceScorecard = checkProjectPermission({ action: "AssuranceScorecard:GetModuleAccess", type: "read" })
  const showActionManagement = checkProjectPermission({ action: "ActionManagement:GetModuleAccess", type: "read" })
  
  const hasSubPermsn = (action: string | string[], type: any) => {
    return checkSubprojectPermission({ action, type, assetId: asset_id! })
  }


  const setupMenuItems = [
    {
      label: `${getKeyValueOrDefaultNested(config, "PSE_LABEL.ABBREVIATION_PRIMARY", "PSE")} Configuration`,
      url: `/process-safety-elements/project/${project_id}/asset/${asset_id}/configuration`,
      disabled: !hasSubPermsn(["GetModuleAccess", "ListQuestion"], ["read", "list"]),
    },
    {
      label: 'Score',
      url: `/process-safety-elements/project/${project_id}/asset/${asset_id}/scores`,
      disabled: !hasSubPermsn(["GetModuleAccess"], "read"),
    },
    {
      label: 'Standard Actions',
      url: `/process-safety-elements/project/${project_id}/asset/${asset_id}/standard-actions`,
      disabled: !hasSubPermsn("ListStandardAction", "list"),
    },
  ]

  const loadsheetMenuItems = [
    {
      label: 'Assessment',
      url: `/process-safety-elements/project/${project_id}/asset/${asset_id}/loadsheet-setup`,
      disabled:!hasSubPermsn("BatchDownloadAssessment", "list") && !hasSubPermsn("BatchUpdateAssessment", "write"),
    },
    {
      label: 'Actions',
      url: `/action-management/project/${project_id}/asset/${asset_id}/pse/action-loadsheet`,
      disabled: !hasSubPermsn("BatchDownloadAssessmentFormAction", "list") && !hasSubPermsn("BatchCreateUpdateAssessmentFormAction", "write"),
    },
  ]

  const dashboardMenuItems = [
    {
      label: 'Barrier Dashboard',
      url: `/hazard-barrier-evaluation/project/${project_id}/asset/${asset_id}`,
      disabled: !showBarrierManagement,
    },
    {
      label: `${getKeyValueOrDefaultNested(config, "PSE_LABEL.ABBREVIATION_PRIMARY", "PSE")} Dashboard`,
      url: `/process-safety-elements/project/${project_id}/asset/${asset_id}/dashboard`,
      disabled: !showProcessSafetyElements,
    },
    {
      label: 'Assurance Scorecard Dashboard',
      url: `/assurance-scorecard/project/${project_id}/asset/${asset_id}`,
      disabled: !showAssuranceScorecard
    },
  ]

    const ActionManagementMenuItems = [
    {
      label: 'Action Management',
      url: `/action-management/project/${project_id}/`,
      disabled: !showActionManagement,
    },
    {
      label: 'Loadsheet',
      // url: `/action-management/project/${project_id}/asset/${asset_id}/pse/action-loadsheet`
      url: `/action-management/project/${project_id}/action-management/action-loadsheet`,
      disabled: !showActionManagement,
    },
  ]

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      display={'flex'}
      alignContent={'center'}
      sx={{ paddingBottom: 2, backgroundColor: '#0070B4', paddingLeft: 3, borderColor: 'white' }}
    >
      <Breadcrumbs separator={<></>} sx={{ paddingLeft: 3, paddingTop: 2 }}>
        <PopupMenu label="Dashboard" items={dashboardMenuItems}  key='dashboards' showOnAllPermission showInList/>
        <PopupMenu label="Setup" items={setupMenuItems} showOnAllPermission showInList/>
        <PopupMenu label="Loadsheet" items={loadsheetMenuItems} showOnAllPermission showInList/>
        <PopupMenu label="Action Management" items={ActionManagementMenuItems} key="dashboards" showOnAllPermission showInList/>

        <LinkRouter underline="hover" color="inherit" to={`#`} variant="body2DMSans">
          <Typography variant="body2DMSans" fontSize={14} color="white">
            Reports
          </Typography>
        </LinkRouter>
      </Breadcrumbs>
    </Stack>
  )
}
